import { sanitize } from "dompurify";
import * as React from "react";
import { isFontOutlines } from "../../../constants/IdFontWithOutlines";
import { utilLoca } from "../../../utils/i18n/utilLoca";
import { ContextLoca } from "../../loca/ContextLoca";
import { FontWithOutline } from "../font-with-outline/FontWithOutline";
export var TextLoca = function (_a) {
    var id = _a.id, replacements = _a.replacements, className = _a.className, style = _a.style;
    return (React.createElement(ContextLoca.Consumer, null, function () {
        var html = {
            __html: sanitize(utilLoca.get(id, replacements)),
        };
        if (isFontOutlines(className)) {
            return (React.createElement(FontWithOutline, { style: className },
                React.createElement("span", { dangerouslySetInnerHTML: html, style: style })));
        }
        return React.createElement("span", { className: className, dangerouslySetInnerHTML: html, style: style });
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/text/TextLoca.tsx
// module id = 9
// module chunks = 3